import React from "react";
import { useTranslation } from "react-i18next";
import { setLanguage } from "@/i18n";

const LangItem = ({ code, label, current }) => (
  <button
    data-testid={`lang-${code}-btn`}
    onClick={() => setLanguage(code)}
    className={`px-2 py-1 rounded-full transition-colors ${current === code ? "bg-[#F4EFE6] text-[#2C2A29]" : "text-[#8C7A6B] hover:text-[#2C2A29]"}`}
  >
    {label}
  </button>
);

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const current = i18n.language;
  return (
    <div className="inline-flex items-center gap-1 text-sm" data-testid="language-switcher">
      <LangItem code="en" label="EN" current={current} />
      <span className="text-[#EAE3D9]">/</span>
      <LangItem code="he" label="עב" current={current} />
      <span className="text-[#EAE3D9]">/</span>
      <LangItem code="fr" label="FR" current={current} />
    </div>
  );
};
